import React from 'react';
import styles from './index.module.scss';

const Credit = () => {
    return (
        <svg xmlns='http://www.w3.org/2000/svg' width='26' height='25.746' viewBox='0 0 26 25.746'>
            <defs>
                <linearGradient id='a' x1='0.5' x2='0.5' y2='1' gradientUnits='objectBoundingBox'>
                    <stop offset='0' stopColor='#ea2c2f' />
                    <stop offset='1' stopColor='#8e0003' />
                </linearGradient>
            </defs>
            <g transform='translate(0 38.956)'>
                <path
                    d='M24.064-38.956H1.936A1.936,1.936,0,0,0,0-37.02v17.05a1.936,1.936,0,0,0,1.936,1.936H7.163A5.846,5.846,0,0,1,13-23.874a5.846,5.846,0,0,1,5.84,5.84h5.222A1.936,1.936,0,0,0,26-19.97V-37.02A1.936,1.936,0,0,0,24.064-38.956Z'
                    fill='url(#a)'
                />
                <circle
                    cx='4.824'
                    cy='4.824'
                    r='4.824'
                    transform='translate(8.178 -22.858)'
                    fill='url(#a)'
                />
                <g transform='translate(1.828 -35.663)'>
                    <path
                        d='M203.577,318.92h-1.83v1.741a.551.551,0,0,1-1.1,0V318.92h-1.833a.551.551,0,0,1,0-1.1h1.833V315.9a.551.551,0,0,1,1.1,0v1.922h1.83a.551.551,0,0,1,0,1.1Z'
                        transform='translate(-190.025 -300.65)'
                        fill='#ff797b'
                    />
                    <g transform='translate(0 0)'>
                        <rect
                            width='4.342'
                            height='0.301'
                            transform='translate(0 1.582)'
                            fill='#ff797b'
                        />
                        <rect
                            width='4.342'
                            height='0.301'
                            transform='translate(0 2.124)'
                            fill='#ff797b'
                        />
                        <path
                            d='M36.232,78.383a.936.936,0,0,0,.1.3h4.12a.936.936,0,0,0,.1-.3Z'
                            transform='translate(-36.22 -75.718)'
                            fill='#ff797b'
                        />
                        <rect
                            width='4.342'
                            height='0.301'
                            transform='translate(0 1.04)'
                            fill='#ff797b'
                        />
                        <path
                            d='M36.331,35.717a.936.936,0,0,0-.1.3H40.55a.936.936,0,0,0-.1-.3Z'
                            transform='translate(-36.22 -35.218)'
                            fill='#ff797b'
                        />
                        <path
                            d='M41.81,89.05a.937.937,0,0,0,.647.258h2.458a.937.937,0,0,0,.647-.258Z'
                            transform='translate(-41.515 -85.843)'
                            fill='#ff797b'
                        />
                        <path
                            d='M45.562,26.153a.938.938,0,0,0-.647-.258H42.457a.938.938,0,0,0-.647.258Z'
                            transform='translate(-41.515 -25.895)'
                            fill='#ff797b'
                        />
                    </g>
                    <g transform='translate(16.527)'>
                        <path
                            d='M363.435,27.628a2.082,2.082,0,0,1,.633-1.5,1.733,1.733,0,1,0,0,2.991A2.082,2.082,0,0,1,363.435,27.628Z'
                            transform='translate(-361.46 -25.895)'
                            fill='#ff797b'
                        />
                        <circle
                            cx='1.733'
                            cy='1.733'
                            r='1.733'
                            transform='translate(2.331)'
                            fill='#ff797b'
                        />
                    </g>
                    <rect
                        width='17.174'
                        height='1.016'
                        rx='0.508'
                        transform='translate(0.203 8.36)'
                        fill='#ff797b'
                    />
                    <rect
                        width='6.147'
                        height='1.016'
                        rx='0.508'
                        transform='translate(0.203 10.543)'
                        fill='#ff797b'
                    />
                </g>
            </g>
        </svg>
    );
};

export default Credit;
